export const ADMIN_MODULES = [
  { key: "cars", label: "Cars", primary: "location", thumbFrom: "images", list: true },
  { key: "brands", label: "Brands", primary: "name", imageField: "image", list: true },
  { key: "models", label: "Models", primary: "name", list: true },
  { key: "body-types", label: "Body Types", primary: "name", imageField: "image", list: true },
  { key: "fuel-types", label: "Fuel Types", primary: "name", list: true },
  { key: "transmissions", label: "Transmissions", primary: "name", list: true },
  { key: "seats", label: "Seats", primary: "name", list: true },
  { key: "car-colors", label: "Colors", primary: "name", list: true },
  { key: "features", label: "Features", primary: "name", list: true },
  { key: "sub-registers", label: "Sub Registers", primary: "name", list: true },
  { key: "states", label: "States", primary: "name", list: true },
  { key: "cities", label: "Cities", primary: "name", list: true },
  { key: "users", label: "Users", primary: "email", list: true },
  { key: "ads", label: "Ads", primary: "duration", imageField: "image", list: true },
  { key: "test-drives", label: "Test Drives", primary: "preferredDate", list: true },
  { key: "protection-orders", label: "Protection Orders", primary: "planName", list: true },
  { key: "why-choose-us", label: "Why Choose Us", primary: "title", list: true },
  { key: "hero", label: "Hero", singleton: true },
  { key: "home-page", label: "Home Page", singleton: true },
  { key: "app-promo", label: "App Promo", singleton: true },
  { key: "contact", label: "Contact Page", singleton: true },
  { key: "privacy", label: "Privacy Policy", singleton: true },
  { key: "about", label: "About Us", singleton: true },
  { key: "site-header", label: "Header", siteConfigKey: "header", singleton: true, schemaKey: "header" },
  { key: "site-auth", label: "Auth Pages", siteConfigKey: "auth", singleton: true, schemaKey: "auth" },
  { key: "site-profile", label: "Profile Page", siteConfigKey: "profile", singleton: true, schemaKey: "profile" },
  { key: "site-sellcar", label: "Sell Car Page", siteConfigKey: "sellcar", singleton: true, schemaKey: "sellcar" },
  { key: "site-valuation", label: "Valuation Page", siteConfigKey: "valuation", singleton: true, schemaKey: "valuation" },
  { key: "site-compare", label: "Compare Page", siteConfigKey: "compare", singleton: true, schemaKey: "compare" },
  { key: "site-car-trust", label: "Car Trust", siteConfigKey: "carTrust", singleton: true, schemaKey: "carTrust" },
  { key: "site-emi", label: "EMI Calculator", siteConfigKey: "emi", singleton: true, schemaKey: "emi" },
  { key: "site-warranty", label: "Warranty Policy", siteConfigKey: "warranty", singleton: true, schemaKey: "warranty" },
];

/** Sidebar groups — partners managed via Partner Management page only */
export const ADMIN_NAV_SECTIONS = [
  {
    title: "Overview",
    links: [
      { to: "/admin", label: "Dashboard", end: true },
      { to: "/admin/notifications", label: "Notifications" },
      { to: "/admin/partner-management", label: "Partner Management" },
    ],
  },
  {
    title: "Inventory",
    moduleKeys: ["cars", "brands", "models", "body-types", "fuel-types", "transmissions", "seats", "car-colors", "features"],
  },
  {
    title: "Locations",
    moduleKeys: ["states", "cities", "sub-registers"],
  },
  {
    title: "Users & Orders",
    moduleKeys: ["users", "test-drives", "protection-orders"],
  },
  {
    title: "Marketing",
    moduleKeys: ["ads", "why-choose-us", "hero", "home-page", "app-promo"],
  },
  {
    title: "Website Pages",
    moduleKeys: ["contact", "privacy", "about"],
  },
  {
    title: "Site Settings",
    moduleKeys: [
      "site-header",
      "site-auth",
      "site-profile",
      "site-sellcar",
      "site-valuation",
      "site-compare",
      "site-car-trust",
      "site-emi",
      "site-warranty",
    ],
  },
];

export const getModuleByKey = (key) => ADMIN_MODULES.find((m) => m.key === key);
